import React from 'react';
import { opts, opts2 } from './change/mock';

export const Options = ({title='Options', path}) => {
 
    return (
        <div className="">
            <Data data={opts} path={path} />
            {title==="Favorites" && <Data data={opts2} path={path} />}
        </div>
    )
}


const Data = ({data, title, path}) =>{

    return (
        <div className="options_component  mb-4-">
            {title && (
            <div className="heading">
                <h4 className="title">{title}</h4>
                <div> </div>
            </div> 
            )}
            <ul>
                {
                    data?.length>0 && data?.map((item,i)=>{
                        return (
                            <li key={'options'+i} className={`${item.sharp&&'red'}`}>
                                <a href={item.url} className={`${item.url===path && 'active'}`}>
                                    <div className="symbol">{item.symbol}</div>
                                    <div>{item.title}</div>
                                </a>
                            </li>
                        
                        )
                    })
                }
            </ul>
        </div>

    )  
}

